var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.value)?_c('div',{staticClass:"text-center"},[(_vm.params.value)?_c('a',{attrs:{"href":_vm.params.data.check_anchor,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.params.value)+"\n  ")]):_c('div',[_vm._v("-")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }